module.exports = __webpack_public_path__ + "static/media/landelijk.46d4a967.jpg";